import eating from '../assets/categories/eating.svg';
import clothing from '../assets/categories/clothing.svg';
import outing from '../assets/categories/outing.svg';
import bathing from '../assets/categories/bathing.svg';
import toys from '../assets/categories/toys.svg';
import mommy from '../assets/categories/mommy.svg';
import sleeping from '../assets/categories/sleeping.svg';
import misc from '../assets/categories/misc.svg';

export const productCategories = [
  {
    id: 'banho',
    image: bathing,
    title: 'Banho & Higiene',
    description:
      'Seja logo cedinho ou antes do almoço... Não importa a hora, mas sim ficar com aquele cheirinho!',
  },
  {
    id: 'brinquedos',
    image: toys,
    title: 'Brinquedinhos',
    description: 'Brincar é viver, aprender, interagir e se divertir!',
  },
  {
    id: 'comidinhas',
    image: eating,
    title: 'Comidinha',
    description:
      'Barriguinha cheia é super importante para dar aquele sorriso, né!?',
  },
  {
    id: 'mamae',
    image: mommy,
    title: 'Mamãe',
    description:
      'Mamãe confortável é bebê confortável. Aqui estão algumas coisinhas para ajudar essa dupla.',
  },
  {
    id: 'passeio',
    image: outing,
    title: 'Passeio',
    description: 'Oba!!! Vamos à rua!?',
  },
  {
    id: 'roupinhas',
    image: clothing,
    title: 'Roupinhas',
    description:
      'Em casa, no parque, onde for, cada lugar e ocasião pede seu traje.',
  },
  {
    id: 'quartinho',
    image: sleeping,
    title: 'Quartinho',
    description: 'Meu lugar favorito! Principalmente para aquela soneca!',
  },
  {
    id: 'outros',
    image: misc,
    title: 'Outros',
    description:
      'Nem tudo tem um lugar próprio... Mas a gente sempre acha um cantinho para tudo.',
  },
];
